// extracted by mini-css-extract-plugin
export default {"content":"dJ-z","lookName":"eJ-z","shopTheLookContainer":"fJ-z","productContainer":"gJ-z","imageContainer":"hJ-z","mainImage":"iJ-z"};